// Brand constants for Archna's Kitchen
export const BRAND = {
  name: "Archna's Kitchen",
  legalName: "Archna's Tiffin Service",
  tagline: "Real Food. Pure Ingredients. Delivered.",
  phoneDisplay: "+91 92679 13203",
  phoneRaw: "919267913203",
  whatsappChat: "https://wa.me/919267913203",
  whatsappGroup: "https://chat.whatsapp.com/IKjLY48kdLcIgNncosI9JN?mode=gi_t",
  location: "Sector 19, Dwarka, New Delhi",
  address: {
    line1: "Green View 3, Flats 97-128, 241 to 248",
    line2: "Sector 19, Pocket 2, Dwarka",
    city: "New Delhi",
    state: "Delhi",
    pin: "110075",
  },
  addressFull:
    "Green View 3, Flats 97-128, 241 to 248, Sector 19, Pocket 2, Dwarka, New Delhi 110075",
  hours: [
    { day: "Mon – Sat", time: "9:00 AM – 10:00 PM" },
    { day: "Sunday", time: "9:00 AM – 4:00 PM" },
  ],
  mapEmbedUrl:
    "https://maps.google.com/maps?q=Green+View+3+Sector+19+Pocket+2+Dwarka+New+Delhi+110075&t=&z=15&ie=UTF8&iwloc=B&output=embed",
  mapDirectionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=Green+View+3%2C+Sector+19%2C+Pocket+2%2C+Dwarka%2C+New+Delhi%2C+110075",
  mapPlaceUrl:
    "https://www.google.com/maps/search/?api=1&query=Archna%27s+Tiffin+Service+Sector+19+Dwarka",
  thaliPrice: 225,
};

export const waOrder = (message = "Hi Archna's Kitchen! I'd like to place an order.") =>
  `${BRAND.whatsappChat}?text=${encodeURIComponent(message)}`;
